'use strict';

require('bootstrap-notify');

import $ from 'jquery';

var $document = $(document);
var $cartForm = $('.js-cart-form');
var promise;

$cartForm.on('change', '.js-shipping-select', function (e) {
    updateCart(
        $(this),
        $(this).parents('form'),
        [
            'shippingdetails',
            'total',
        ]
    );
});

$cartForm.on('change', '.js-shipping-country', function (e) {
    updateCart(
        $(this),
        $(this).parents('form'),
        [
            'shippingdetails',
            'currentshipping',
            'total',
        ]
    );
});

$cartForm.on('change', '.js-qty', function (e) {
    updateCart(
        $(this),
        $(this).parents('form'),
        [
            //'qty',
            'price',
            'total',
        ]
    );
});

$cartForm.on('click', '.js-cart-remove', function (e) {
    updateCart(
        $(this),
        $(this).parents("form"),
        [
            'total',
            'carticon',
            'cartOverview'
        ]
    );
    $(this).parents('.js-cart-product').remove();

    //notify when cart is updated
    $.notify({
        // options
        icon: 'icon icon--cart',
        title: 'Product removed from cart',
        url: '/cart',
    }, {
        // settings
        element: 'body',
        position: null,
        type: "danger",
        allow_dismiss: true,
        newest_on_top: false,
        showProgressbar: false,
        placement: {
            from: "top",
            align: "right"
        },
        offset: 20,
        spacing: 10,
        z_index: 1031,
        //delay: 5000,
        timer: 1000,
        mouse_over: null,
        animate: {
            enter: 'animated fadeInRight',
            exit: 'animated fadeOutRight'
        },
        onShow: null,
        onShown: null,
        onClose: null,
        onClosed: null,
        icon_type: 'class',
        template:   '<div data-notify="container" class="notice notice--danger alert-{0}" role="alert">' +
                        '<button type="button" aria-hidden="true" class="link close notice__close" data-notify="dismiss" style="border: none; background: none; outline: none;">×</button>' +
                        '<span data-notify="icon"></span> &nbsp; ' +
                        '<span data-notify="title">{1}</span> ' +
                        '<div class="progress" data-notify="progressbar">' +
                            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
                        '</div>' +
                        '<a href="{3}" data-notify="url"></a>' +
                    '</div>'
    });
});



function updateCart($field, $form, replaceTypes) {
    if (typeof replaceTypes === 'undefined') {
        replaceTypes = [];
    }

    $field.parsley().reset();
    $field.parsley().validate();

    if (promise) {
        promise.abort();
    }

    var data = $form.serializeArray();
    data[window.csrfTokenName] = window.csrfTokenValue;

    promise =    $.ajax({
        url: '',
        dataType: 'json',
        type: 'post',
        data: data,
    });

    promise.then(function (response) {;
        if (typeof response.error !== 'undefined') {
            $field.parsley().addError('forcederror', { message: response.error, updateClass: true });
            /*if (response.cart.errors) {
                $field.parsley().addError('forcederror', { message: response.cart.errors['lineItems.1.qty'][0], updateClass: true });
            } else {
                $field.parsley().addError('forcederror', { message: response.error, updateClass: true });
            }*/
        } else {
            $.each(replaceTypes, function (index, value) {
                replaceContent(value, $field.data('id'));
            });
        }
    });
}

function replaceContent(type, id) {
    if (type == 'total' || type == 'shippingdetails' || type == 'currentshipping') { // update elements that output only one line (example: 14.5 EUR)
        var request = $.get('/callback/' + type);

        request.then(function(html) {
            $document.find('.cart-' + type).html(html);
        }, function(error) {
            console.log(error);
        });
    } else if (type != 'price') { //update elements with tags
        var request = $.get('/callback/' + type);

        request.then(function(html) {
            var $html = $(html);
            $document.find('.cart-' + type).html($html);
        }, function(error) {
            console.log(error);
        });
    } else if (type == 'price') { //update price
        var request = $.get('/callback/' + type + '?id=' + id);

        request.then(function(html) {
            var $html = $(html);
            $document.find('.cart-' + type + '-'+ id).html($html);
        }, function(error) {
            console.log(error);
        });
    } else { //updates for line items (with id)
        var request = $.get('/callback/' + type + '?id=' + id);

        request.then(function(html) {
            $document.find('.cart-' + type + '-'+ id).html(html);
        }, function(error) {
            console.log(error);
        });
    }
}



